import { render, staticRenderFns } from "./cModalDetalleReporte.vue?vue&type=template&id=1a5541a9&scoped=true"
import script from "./cModalDetalleReporte.vue?vue&type=script&lang=js"
export * from "./cModalDetalleReporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5541a9",
  null
  
)

export default component.exports